import { Dispatcher } from 'flux'
import {
  changePhysical,
  changeReading,
  changeSetting,
  changeDevice,
  getBrand,
  getCustomerDevices,
  getCustomerUsers,
  getDevice,
  getDeviceReadings,
  getDeviceRules,
  getDevices,
  getDoc,
  getDocs,
  getGroup,
  getGroups,
  getRule,
  getRules,
  getReading,
  getMetric,
  getMetricAddress,
  getMoistureSensorStats,
  getPumpStats,
  getValveStats,
  getStatsAddress,
  getStatsAddressFlow,
  getSettingHistory,
  getCustomers,
  getCustomerRelations,
  getSearchedCustomer,
  getUserCustomer,
  getUserEmail,
  getCustomerApiKeys,
  getUserGroups,
  initializeNewSettings,
  invalidSetting,
  loadDeviceStatus,
  login,
  resetPopup,
  resetNewSettings,
  resetSettingsSavedStatus,
  saveHistory,
  saveHistoryList,
  saveSettings,
  selectDevice,
  selectDevices,
  selectDevicesRemove,
  setGroup,
  setRule,
  setSettings,
  setSort,
  setUserGroup,
  storeNewRule,
  storeRule,
  switchCustomer,
  unloadDeviceRules,
  unloadDeviceStatus,
  unloadMetric,
  unloadReading,
  unloadSettingHistory,
  unloadRule,
  unloadUserGroups,
  unloadGroupDevices,
  unloadFlowStats,
  updateCustomer,
  setDevice,
  setDevices,
  swapModem,
  setPhysical,
  updateNewRuleBasic,
  updateNewRuleContactInfo,
  updateNewRuleParameters,
  updateUserCustomer,
} from '../actions/actions'

import {
  pinCodeAuthenticate,
  pinCodeCancel,
  pinCodeChange,
  pinCodeReset,
  pinCodeUnload,
} from '../actions/pinCode'

import {
  getUser,
  getCustomer,
  updateUser,
  unloadUserChange,
} from '../actions/user'

import {
  connectionIssues,
} from '../actions/errors'

const AppDispatcher = new Dispatcher()

// Register callback with AppDispatcher
AppDispatcher.register((payload) => {
  const {
    action,
    active,
    address,
    addresses,
    body,
    callback,
    change,
    code,
    connection,
    customerID,
    data,
    debounceTime,
    device,
    deviceID,
    alias,
    deviceGroup,
    deviceType,
    direction,
    docID,
    email,
    error,
    formula,
    group,
    groupID,
    id,
    invalid,
    method,
    multiplier,
    name,
    newPin,
    nextNotification,
    notificationInterval,
    noEvent,
    oldPin,
    params,
    path,
    physical,
    includes,
    relation,
    isActive,
    reading,
    readingID,
    rule,
    ruleID,
    sendOnce,
    sensor,
    selectedCompany,
    setting,
    settings,
    status,
    subject,
    template,
    test,
    testValue,
    timeBeg,
    timeEnd,
    type,
    update,
    userGroup,
    userID,
    utcOffset,
    valueKey,
    value1,
    value2,
    convert,
    ids,
    offset,
    limit,
  } = payload

  switch (action) {
    case 'change-physical' : changePhysical(setting, callback); break
    case 'change-setting' : changeSetting(setting); break
    case 'change-device' : changeDevice(data); break
    case 'connection-issue' : connectionIssues(error, connection); break
    case 'get-brand' : getBrand(name); break
    case 'get-customer' : getCustomer(customerID); break
    case 'get-searched-customer' : getSearchedCustomer(customerID, userID, callback); break
    case 'get-customers' : getCustomers(customerID); break
    case 'get-customer-relations' : getCustomerRelations(customerID, relation); break
    case 'get-customer-devices' : getCustomerDevices(customerID, callback); break
    case 'get-customer-users' : getCustomerUsers(customerID, callback); break
    case 'get-device' : getDevice(deviceID, callback); break
    case 'get-devices' : getDevices(deviceType, deviceGroup, customerID, groupID, isActive); break
    case 'get-device-readings' : getDeviceReadings(timeBeg, timeEnd, deviceID, convert); break
    case 'get-device-rules' : getDeviceRules(address); break
    case 'get-doc' : getDoc(docID, params); break
    case 'get-docs' : getDocs(params, callback); break
    case 'get-group' : getGroup(groupID, params, callback); break
    case 'get-groups' : getGroups(params, callback); break
    case 'get-metric' : getMetric(deviceID, timeBeg, timeEnd); break
    case 'get-metric-address' : getMetricAddress(address, timeBeg, timeEnd); break
    case 'get-moisture-sensor-stats' : getMoistureSensorStats(deviceID, timeBeg, timeEnd); break
    case 'get-pump-stats' : getPumpStats(deviceID, timeBeg, timeEnd, utcOffset); break
    case 'get-valve-stats' : getValveStats(deviceID, timeBeg, timeEnd, utcOffset); break
    case 'get-reading' : getReading(readingID); break
    case 'get-rule' : getRule(ruleID, callback); break
    case 'get-rules' : getRules(customerID, params); break
    case 'get-stats-address' : getStatsAddress(address, timeBeg, timeEnd, valueKey); break
    case 'get-stats-flow-address' : getStatsAddressFlow(address, timeBeg, timeEnd); break
    case 'get-setting-history' : getSettingHistory(deviceID, offset, limit, timeBeg, timeEnd); break
    case 'unload-settings-history' : unloadSettingHistory(); break
    case 'get-user' : getUser(); break
    case 'get-user-email' : getUserEmail(email, includes); break
    case 'get-user-customer' : getUserCustomer(userID, customerID, params, callback); break
    case 'get-user-groups' : getUserGroups(params, callback); break
    case 'get-customer-api-keys' : getCustomerApiKeys(customerID, callback); break
    case 'initialize-new-settings' : initializeNewSettings(device); break
    case 'invalid-setting' : invalidSetting(invalid); break
    case 'load-device-status' : loadDeviceStatus(status); break
    case 'login' : login(); break
    case 'new-reading' : changeReading(reading, 'noID', false); break
    case 'pin-code-cancel' : pinCodeCancel(); break
    case 'pin-code-reset' : pinCodeReset(); break
    case 'pin-code-unload' : pinCodeUnload(); break
    case 'save-history' : saveHistory(path); break
    case 'save-history-list' : saveHistoryList(path); break
    case 'pin-code-authenticate' : pinCodeAuthenticate(code); break
    case 'reset-new-settings' : resetNewSettings(); break
    case 'reset-popup' : resetPopup(); break
    case 'reset-settings-saved-status' : resetSettingsSavedStatus(); break
    case 'save-settings' : saveSettings(); break
    case 'selected-device-add' : selectDevice(id, true); break
    case 'selected-device-remove' : selectDevice(id, false); break
    case 'selected-devices-remove-all' : selectDevicesRemove(callback); break
    case 'select-multiple-devices' : selectDevices(ids); break
    case 'set-group' : setGroup(group, update, callback); break
    case 'set-sort' : setSort(direction, value1, value2); break
    case 'set-rule' : setRule(ruleID, rule, update, callback); break
    case 'set-settings' : setSettings(settings, callback); break
    case 'set-device' : setDevice(deviceID, data, callback); break
    case 'set-devices' : setDevices(data, callback); break
    case 'swap-modem' : swapModem(deviceID, data, callback); break
    case 'set-physical' : setPhysical(deviceID, data, callback); break
    case 'set-user-group' : setUserGroup(userGroup, update, params, callback); break
    case 'store-new-rule' : storeNewRule(rule, noEvent, callback); break
    case 'store-rule' : storeRule(ruleID, callback); break
    case 'switch-customer' : switchCustomer(customerID, userID, selectedCompany, callback); break
    case 'unload-device-rules' : unloadDeviceRules(); break
    case 'unload-device-status' : unloadDeviceStatus(); break
    case 'unload-reading' : unloadReading(); break
    case 'unload-rule' : unloadRule(); break
    case 'unload-user-groups' : unloadUserGroups(); break
    case 'unload-metric' : unloadMetric(); break
    case 'unload-group-devices' : unloadGroupDevices(); break
    case 'unload-flow-stats' : unloadFlowStats(); break
    case 'update-customer' : updateCustomer(customerID, data, callback); break
    case 'update-reading' : changeReading(reading, readingID, true); break
    case 'update-user' : updateUser(userID, change, callback); break
    case 'update-user-pin' : pinCodeChange(oldPin, newPin); break
    case 'unload-user-change' : unloadUserChange(); break
    case 'update-new-rule-basic' : updateNewRuleBasic(address, active, nextNotification); break
    case 'update-new-rule-contact-info' : updateNewRuleContactInfo(addresses, method, invalid); break
    case 'update-new-rule-parameters' :
      updateNewRuleParameters(
        template,
        test,
        formula,
        valueKey,
        testValue,
        multiplier,
        body,
        subject,
        debounceTime,
        sendOnce,
        notificationInterval,
        type,
        invalid,
        sensor
      )
      break
    case 'update-user-customer' : updateUserCustomer(userID, customerID, data, callback); break

    default:
      return true
  }

  return true
})

export default AppDispatcher
